import React from 'react';

function AlertMessage({ message }) {
	return (
		<div>
			<h1>{message}</h1>
		</div>
	);
}

export default AlertMessage;
